﻿import { FIQAssist } from "../app";
import { Inject, Injectable } from "@fiqas/angular-utils";
import { LiteEvent } from "../interfaces/iLiteEvent";

@Injectable({
    module: FIQAssist,
    selector: IsProcessingService.selector
})
/**
 * Session class, stores values as JSON in local browser storage.
 */
export class IsProcessingService {
    public static selector = "IsProcessingService";

    public IsProcessing: boolean = false;
    private busyCount: number = 0;
    private publisher: LiteEvent<boolean>;
    constructor() {
        this.publisher = new LiteEvent();
    }

    public StartProcessing() {
        this.busyCount++;

        if (!this.IsProcessing) {
            this.IsProcessing = true;
            this.publisher.trigger(this.IsProcessing);
        }
    }
    public StopProcessing() {
        if (this.busyCount > 0)
            this.busyCount--;

        if (this.busyCount == 0) {
            this.IsProcessing = false;
            this.publisher.trigger(this.IsProcessing);
        }
    }

    public addListener(listener: (boolean) => void): () => void {
        this.publisher.on(listener);
        return () => { this.publisher.off(listener); };
    }

    public reset() {
        this.IsProcessing = false;
        this.busyCount = 0;
        this.publisher.trigger(this.IsProcessing);
    }
}